// export default function getData (data) {
//     return {
//       tooltip: {
//         trigger: 'axis',
//         axisPointer: {
//             type: 'cross',
//             animation: false,
//             label: {
//                 backgroundColor: '#ccc',
//                 borderColor: '#aaa',
//                 borderWidth: 1,
//                 shadowBlur: 0,
//                 shadowOffsetX: 0,
//                 shadowOffsetY: 0,
//                 textStyle: {
//                     color: '#222'
//                 }
//             }
//         },
//         formatter: function (params) {
//           return params[0].seriesName + ': ' + params[0].value + '笔'
//                  + '<br />' + params[1].seriesName + ': ' + params[1].value + '笔'
//                  + '<br />' + params[2].seriesName + ': ' + params[2].value + '笔'
//                  + '<br />' + params[3].seriesName + ': ' + params[3].value + '笔'
//                  + '<br />' + params[4].seriesName + ': ' + params[4].value + '笔'
//                  + '<br />' + params[5].seriesName + ': ' + params[5].value + '笔'
//         }
//       },
//       legend: [
//         {
//           data: ['查询打印', '理财服务', '其它服务'],
//           y: 'bottom',
//           show: true,
//           textStyle: {
//             fontSize: 10,
//             color: '#fff',
//             fontWeight: 'normal'
//           },
//           icon: 'rect',
//           itemWidth: 6,
//           itemHeight: 6,
//           itemGap: 4,
//         },
//         {
//           bottom: '14',
//           data: ['开户服务', '存贷转账', '账户服务'],
//           textStyle: {
//             fontSize: 10,
//             color: '#fff',
//             fontWeight: 'normal'
//           },
//           icon: 'rect',
//           itemWidth: 6,
//           itemHeight: 6,
//           itemGap: 4,
//         },
//       ],
//       xAxis: {
//         type: 'category',
//         data: data.legendData,
//         axisLabel:{
//           textStyle: {
//             fontSize: 10,
//             fontWeight: 'normal',
//             color: '#fff'
//           }
//         },
//         "axisLine":{       //y轴
//           "show": true,
//           "lineStyle": {
//             color: '#b6b9c2'
//           }
//         },
//       },
//       yAxis: {
//           type: 'value',
//           "axisLine":{       //y轴
//             "show":false
//           },
//           "axisTick":{       //y轴刻度线
//             "show": false
//           },
//           "splitLine": {     //网格线
//             "show": true
//           },
//           name: '单位：笔',
//           nameTextStyle: {
//             color: '#fff',
//             fontSize: 10,
//             padding: [0, 0, 0, 14]
//           },
//           axisLabel:{
//             textStyle: {
//               fontSize: 10,
//               fontWeight: 'normal',
//               color: '#fff'
//             },
//             formatter: function (val) {
//               return val;
//             }
//           }
//       },
//       grid: {
//         top: '16%',
//         bottom: '32%',
//         left: '12%',
//         right: '12%'
//       },
//       series:[{
//         name: '开户服务',
//         type: 'line',
//         smooth: true,
//         itemStyle: {
//           normal: {
//             color: '#63e5ee'
//           }
//         },
//         data: data.seriesData.map(function (item) { 
//           return item.accountOpeningService;
//         })
//         },{
//           name: '存贷转账',
//           type: 'line',
//           smooth: true,
//           itemStyle: {
//             normal: {
//               color: '#8f92e8'
//             }
//           },
//           data: data.seriesData.map(function (item) {
//             return item.depositAndLoanTransfer;
//           })
//       },{
//           name: '账户服务',
//           type: 'line',
//           smooth: true,
//           itemStyle: {
//             normal: {
//               color: '#ed0fee'
//             }
//           },
//           data: data.seriesData.map(function (item) { 
//             return item.accountService;
//           })
//       },{
//           name: '查询打印',
//           type: 'line',
//           smooth: true,
//           itemStyle: {
//             normal: {
//               color: '#6b2cd1'
//             }
//           },
//           data: data.seriesData.map(function (item) {
//             return item.queryPrint;
//           })
//       },{
//           name: '理财服务',
//           type: 'line',
//           smooth: true,
//           itemStyle: {
//             normal: {
//               color: '#fc79f2'
//             }
//           },
//           data: data.seriesData.map(function (item) { 
//             return item.financialService;
//           })
//       },{
//         name: '其它服务',
//         type: 'line',
//         smooth: true,
//         itemStyle: {
//           normal: {
//             color: '#fff799'
//           }
//         },
//         data: data.seriesData.map(function (item) {
//           return item.otherService;
//         })
//       }]
//     }
//   }
export default function getData (data) {
  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
          type: 'cross',
          animation: false,
          label: {
              backgroundColor: '#ccc',
              borderColor: '#aaa',
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              textStyle: {
                  color: '#222'
              }
          }
      },
      formatter: function (params) {
        return params[0].seriesName + ': ' + params[0].value + '笔'
               + '<br />' + params[1].seriesName + ': ' + params[1].value + '笔'
               + '<br />' + params[2].seriesName + ': ' + params[2].value + '笔'
               + '<br />' + params[3].seriesName + ': ' + params[3].value + '笔'
               + '<br />' + params[4].seriesName + ': ' + params[4].value + '笔'
               + '<br />' + params[5].seriesName + ': ' + params[5].value + '笔'
      }
    },
    legend: [
      {
        data: ['开户', '转账', '其它'],
        y: 'bottom',
        show: true,
        textStyle: {
          fontSize: 10,
          color: '#fff',
          fontWeight: 'normal'
        },
        icon: 'rect',
        itemWidth: 6,
        itemHeight: 6,
        itemGap: 4,
      },
      {
        bottom: '14',
        data: ['存款', '取款', '理财'],
        textStyle: {
          fontSize: 10,
          color: '#fff',
          fontWeight: 'normal'
        },
        icon: 'rect',
        itemWidth: 6,
        itemHeight: 6,
        itemGap: 4,
      },
    ],
    xAxis: {
      type: 'category',
      data: data.legendData,
      axisLabel:{
        textStyle: {
          fontSize: 10,
          fontWeight: 'normal',
          color: '#fff'
        }
      },
      "axisLine":{       //y轴
        "show": true,
        "lineStyle": {
          color: '#b6b9c2'
        }
      },
    },
    yAxis: {
        type: 'value',
        "axisLine":{       //y轴
          "show":false
        },
        "axisTick":{       //y轴刻度线
          "show": false
        },
        "splitLine": {     //网格线
          "show": true
        },
        name: '单位：笔',
        nameTextStyle: {
          color: '#fff',
          fontSize: 10,
          padding: [0, 0, 0, 14]
        },
        axisLabel:{
          textStyle: {
            fontSize: 10,
            fontWeight: 'normal',
            color: '#fff'
          },
          formatter: function (val) {
            return val;
          }
        }
    },
    grid: {
      top: '16%',
      bottom: '32%',
      left: '15%',
      right: '12%'
    },
    series:[{
      name: '存款',
      type: 'line',
      smooth: true,
      itemStyle: {
        normal: {
          color: '#63e5ee'
        }
      },
      data: data.seriesData.map(function (item) { 
        return item.deposit;
      })
      },{
        name: '取款',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            color: '#8f92e8'
          }
        },
        data: data.seriesData.map(function (item) {
          return item.withdraw;
        })
    },{
        name: '理财',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            color: '#ed0fee'
          }
        },
        data: data.seriesData.map(function (item) { 
          return item.financing;
        })
    },{
        name: '开户',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            color: '#6b2cd1'
          }
        },
        data: data.seriesData.map(function (item) {
          return item.account;
        })
    },{
        name: '转账',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            color: '#fc79f2'
          }
        },
        data: data.seriesData.map(function (item) { 
          return item.transfer;
        })
    },{
      name: '其它',
      type: 'line',
      smooth: true,
      itemStyle: {
        normal: {
          color: '#fff799'
        }
      },
      data: data.seriesData.map(function (item) {
        return item.other;
      })
    }]
  }
}


// WEBPACK FOOTER //
// ./src/views/dataIndex/data/business.js